import React from "react";
import ProjectDetail from "./ProjectDetail";
function Projets() {
    return (
        <section className="section">
            <div>
                <ProjectDetail />
            </div>
        </section>
    );
}

export default Projets;